/** @format */

import { payOptionUrl } from '../Config/Url';
import axios from 'axios';

export const payOptionService = {
	get,
	update,
	create,
	getById,
	deletePayOption,
};

async function get({ searchName, pageIndex, pageSize }) {
	return axios
		.put(`${payOptionUrl}/search`, { searchName, pageIndex, pageSize })
		.then(res => res)
		.catch(err => {
			console.log('err', err.response);
		});
}

async function update({ payOptionId, name, tag, fiscalTag, useFiscalization }) {
	return axios
		.put(`${payOptionUrl}/${payOptionId}`, {
			name,
			tag,
			fiscalTag,
			useFiscalization,
		})
		.then(res => res)
		.catch(err => {
			console.log('err', err.response);
		});
}

async function getById(payOptionId) {
	return axios
		.get(`${payOptionUrl}/${payOptionId}`)
		.then(res => res)
		.catch(err => err.response.data);
}

async function create({ name, tag, fiscalTag, useFiscalization }) {
	return axios
		.post(payOptionUrl, {
			name,
			tag,
			fiscalTag,
			useFiscalization,
		})
		.then(res => res)
		.catch(err => {
			console.log('err', err.response);
		});
}

async function deletePayOption(PayOptionId) {
	return axios
		.delete(`${payOptionUrl}/${PayOptionId}`)
		.then(res => res)
		.catch(err => err.response);
}
